import { render, staticRenderFns } from "./BaseLanguageSwitcher.vue?vue&type=template&id=2029e055&scoped=true&"
import script from "./BaseLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./BaseLanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BaseLanguageSwitcher.vue?vue&type=style&index=0&id=2029e055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029e055",
  null
  
)

export default component.exports